export const fonts = Object.freeze({
  'Arial': 'Arial, Helvetica, sans-serif',
  'Arial Black': '"Arial Black", Gadget, sans-serif',
  'Comic Sans MS': '"Comic Sans MS", cursive, sans-serif',
  'Courier New': '"Courier New", Courier, monospace',
  'Georgia': 'Georgia, serif',
  'Impact': 'Impact, Charcoal, sans-serif',
  'Lucida Console': '"Lucida Console", Monaco, monospace',
  'Lucida Sans Unicode': '"Lucida Sans Unicode", "Lucida Grande", sans-serif',
  'Palatino': '"Palatino Linotype", "Book Antiqua", Palatino, serif',
  'Tahoma': 'Tahoma, Geneva, sans-serif',
  'Times New Roman': '"Times New Roman", Times, serif',
  'Trebuchet MS': '"Trebuchet MS", Helvetica, sans-serif',
  'Verdana': 'Verdana, Geneva, sans-serif'
});

// Fix the difference between CSS pt and Java pt
// http://www.3rd-evolution.de/tkrammer/docs/java_font_size.html
export function adaptJavaFontSize (size) {
  return (parseFloat(size) * 72 / 96) + 'pt';
}
